import { render, staticRenderFns } from "./FooterSlfuntapVn.vue?vue&type=template&id=b8bc8d76&scoped=true&"
import script from "./FooterSlfuntapVn.vue?vue&type=script&lang=js&"
export * from "./FooterSlfuntapVn.vue?vue&type=script&lang=js&"
import style0 from "./FooterSlfuntapVn.vue?vue&type=style&index=0&id=b8bc8d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bc8d76",
  null
  
)

component.options.__file = "FooterSlfuntapVn.vue"
export default component.exports